class ProductPage {
  constructor(container) {
    this.container = container;
    $(".product_form").on("keyup change paste", "input", () => {
      this.checkSwatches();
    });
    $(document)
      .ready(() => {
        this.resize();
        this.checkSwatches();
      })
      .bind(this);

    $(document).on("click", ".product__image__thumbs a", event => {
      event.preventDefault();
  
      var videoLoaded = $("video").length;
      if(videoLoaded) {
        $("video").get(0).pause();
        $("video").get(1).pause();
      }

      if (this.currentCarousel) {
        this.currentCarousel.slideToLoop($(event.currentTarget).index());
      }
    });
    $(window)
      .on("resize", () => {
        this.resize();
      })
      .bind(this);

    $(document)
      .on("click", "#desktop-carousel .swiper-wrapper img", event => {
        event.preventDefault();
        this.positionZoomImage(event.offsetX, event.offsetY);
        this.activateZoomImage($(event.currentTarget).attr("src"));
      })
      .bind(this);

    $(".zoom-image").click(this.deactivateZoomImage);
    this.$zoomImage = $(".zoom-image");

    this.$zoomImage
      .mousemove(event => {
        this.positionZoomImage(event.offsetX, event.offsetY);
      })
      .bind(this);
  }

  map(input, in_min, in_max, out_min, out_max) {
    return (
      ((input - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  }

  positionZoomImage(x, y) {
    const maxX = this.$zoomImage.innerWidth();
    const maxY = this.$zoomImage.innerHeight();
    let scaledX = this.map(x, 0, maxX, 0, 100);
    let scaledY = this.map(y, 0, maxY, 0, 100);
    this.$zoomImage.css({
      "background-position": `${scaledX}% ${scaledY}%`
    });
  }

  activateZoomImage(url) {
    $(".zoom-image")
      .css({
        "pointer-events": "auto",
        opacity: 1,
        "background-image": `url('${url}')`
      })
      .mousemove();
  }

  deactivateZoomImage() {
    $(".zoom-image")
      .css({
        "pointer-events": "none",
        opacity: 0
      })
      .mousemove();
  }

  resize() {
    const $carousel = $(".product__image__group");
    var vpWidth = $(window).width();
    if (vpWidth > 768) {
      $carousel.appendTo($(".product__image--desktop"));
    } else {
      $carousel.appendTo($(".product__image--mobile"));
    }
  }

  getSwatchSlug(swatchName) {
    if (typeof swatchName === "undefined") {
      return "";
    }
    let updated = swatchName
      .toLowerCase()
      .replace(/ & /g, " ")
      .replace(/&/g, " ");
    updated.replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    return updated.replace(/\//g, "-").replace(/ /g, "-");
  }

  checkSwatches() {
    var colorLookup = $(".color-list input:checked").val();
    if (colorLookup) {
      let slug = this.getSwatchSlug(colorLookup);
      if (slug !== this.slug) {
        this.updateCarousel(slug);
      }
      this.slug = slug;
    } else {
      // no swatches, we display them all
      this.slug = null;
      console.log("no slug");
      this.updateCarousel();
    }
  }

  updateCarousel(swatch) {
    this.deactivateZoomImage();
    let swatchImages;
    if (swatch) {
      swatchImages = productImages.filter(item => {
        return item.slug === swatch;
      });
    } else {
      swatchImages = productImages;
    }
    if (this.currentCarousel && this.currentCarousel.destroy) {
      this.currentCarousel.destroy(true, true);
    }
    $(".product__image__photos").attr(
      "style",
      `width: ${$(".product__image__photos").width()}px`
    );
    $(".product__image__thumbs").empty();
    $(".product__image__photos").empty();
    $(".product__image__photos").append(
      $('<div class="swiper-wrapper"></div>')
    );

    swatchImages.forEach(img => {
      if (swatchImages.length > 1) {
        $(".product__image__thumbs").append(
          $(`<a href="#" aria-label="Jump to image">
              <img src="${img.thumb}" alt="${img.color}">
            </a>`
          )
        );
      }
      $(".swiper-wrapper").append(
        $(
          `<div class="swiper-slide product__image__photos--slide">
            <img src="${img.large}" class="" alt="${img.color}">
          </div>`
        )
      );
    });

    var variant_image_message = '';

    swatchImages.forEach(img => {
      if(variant_image_message == '') {
        var img_variants = $.parseJSON(img.variants);

        img_variants.forEach(img_variant => {
          if(variant_image_message == '') {
            var variant_image_message_selector = $(".variant_metafield[data-variant-id=" + img_variant.id + "] span");
            
            if (variant_image_message_selector.length > 0) {
              variant_image_message = variant_image_message_selector[0].innerText;
            }
          }
        });
      }
    });

    $('.variant_image_message').text( variant_image_message);
      
    var productMetafield = $(".product_metafield");

    if(productMetafield.length > 0) {
      var productVideoThumbnail = $($(productMetafield[0]).find(".product_metafield__video_thumbnail")[0]).data("video-thumbnail");
      var productVideoUrl = $($(productMetafield[0]).find(".product_metafield__video_url")[0]).data("video-url");
      var productVideoModel = $(productMetafield[0]).find(".product_metafield__video_model")[0];
      $(".product__image__thumbs").append($("<a href=\"#\" aria-label=\"Jump to image\"><img\n            src=\"".concat(productVideoThumbnail, "\" alt=\"").concat("\"><svg width='30pt' height='30pt' version='1.1' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' style='position: absolute; left: 20px; bottom: 40px;'><path d='m50 12c-20.988 0-38 17.012-38 38s17.012 38 38 38 38-17.012 38-38-17.012-38-38-38zm-11 20l30 18-30 18z'></path></svg></a>")));
      if(productVideoModel) {
        productVideoModel = productVideoModel.innerText;
        $(".swiper-wrapper").append($("<div class=\"swiper-slide product__image__photos--slide\"><video controls preload=\"none\" style=\"width:100%; cursor: default;\" poster=\"".concat(productVideoThumbnail, "\"><source src=\"".concat(productVideoUrl, "\" type='video/mp4' /></video><div style=\"font-size: 12px; cursor: default;\">" + productVideoModel + "</span></div>"))));
      } else {
        $(".swiper-wrapper").append($("<video controls preload=\"none\" class=\"swiper-slide product__image__photos--slide\" style=\"width:100%; cursor: default;\" poster=\"".concat(productVideoThumbnail, "\"><source src=\"".concat(productVideoUrl, "\" type='video/mp4' /></video>"))));
      }
    }

    this.currentCarousel = new Swiper(".product__image__photos", {
      // autoHeight: true, can't use with first image being lazyloaded
      slidesPerView: 1,
      loop: swatchImages.length > 0,
      speed: 500,
      direction: "horizontal",
      navigation: {
        nextEl: ".product-button-next",
        prevEl: ".product-button-prev"
      },
      pagination: {
        el: ".product-pagination",
        type: 'bullets',
      },
      on: {
        imagesReady: () => {
          $(".product-template-alt").css({ opacity: 1 });
          if (swatchImages.length > 1) {
            $(".product-button-prev").show();
            $(".product-button-next").show();
            $(".product-pagination").show();
          } else {
            $(".product-button-prev").hide();
            $(".product-button-next").hide();
          }
          $(".product__image__photos").attr("style", "");
          if (this.currentCarousel && this.currentCarousel.update) {
            this.currentCarousel.update();
          }
        }
      }
    });
    setTimeout(() => {
      if (this.currentCarousel && this.currentCarousel.update) {
        this.currentCarousel.update();
      } else {
        setTimeout(() => {
          this.currentCarousel.update();
        }, 1500);
      }
    }, 300);
    //$('.product__image__photos').css({ width: null });
  }
}

const container = document.querySelector("#ProductSection-product-template");
if (container) {
  new ProductPage(container);
}

